module.exports = __webpack_public_path__ + "img/animalPlaceholder.7604e7a1.png";